import { render, staticRenderFns } from "./IcoArrowBack.vue?vue&type=template&id=84d6149a&lang=html"
import script from "./IcoArrowBack.vue?vue&type=script&lang=js"
export * from "./IcoArrowBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports